'use client';

import { useEffect, useRef } from 'react';

interface Props {
  stream: MediaStream;
  className?: string;
}

export default function ProjectUsabilityCameraVideo({
  stream,
  className,
}: Props) {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const el = videoRef.current;
    if (!el) return;
    el.srcObject = stream;
    el.play().catch(() => undefined);
    return () => {
      el.srcObject = null;
    };
  }, [stream]);

  return (
    <video
      ref={videoRef}
      autoPlay
      muted
      playsInline
      className={className}
      data-test='ut-camera-video'
    />
  );
}
